

export const ContactCardSkeleton = ({ value }) => {
    const socialLinkLength = 4
    return (
        <div
            key={value}
            className="position-relative d-flex flex-column px-3"
            style={{
                padding: '10px',
                width: '260px',
                maxHeight: '300px',
                minHeight: '280px',
                borderRadius: "5px",
                marginTop: '20px',
                boxShadow: "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                animation: "pulse 1.5s infinite ease-in-out"
            }}
        >
            {/* top option button skeleton */}
            <div
                className="position-absolute d-flex flex-column justify-content-center align-items-center"
                style={{
                    top: '10px',
                    right: '10px',
                    width: '20px',
                    height: '20px',
                    borderRadius: '50%',
                    backgroundColor: "#f0f0f0",
                    gap: 2,
                    cursor: "pointer"
                }}
            >
                <span style={{
                    width: '3px',
                    height: "3px",
                    borderRadius: "50%",
                    backgroundColor: "#e0e0e0"
                }}></span>
                <span style={{
                    width: '3px',
                    height: "3px",
                    borderRadius: "50%",
                    backgroundColor: "#e0e0e0"
                }}></span>
                <span style={{
                    width: '3px',
                    height: "3px",
                    borderRadius: "50%",
                    backgroundColor: "#e0e0e0"
                }}></span>
            </div>

            {/* user image skeleton */}
            <div className="d-flex flex-column align-items-center gap-2">
                <div
                    className="rounded-circle overflow-hidden border border-3"
                    style={{
                        width: '60px',
                        height: '60px',
                        backgroundColor: '#f0f0f0',
                        borderColor: '#e0e0e0 !important'
                    }}
                ></div>

                {/* username skeleton */}
                <div
                    style={{
                        width: '100px',
                        height: '12px',
                        backgroundColor: '#f0f0f0',
                        borderRadius: '4px'
                    }}
                ></div>
            </div>

            {/* contact info skeleton */}
            <div style={{ marginTop: '8px', display: "flex", flexDirection: "column", gap: 12 }}>
                {/* email skeleton */}
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <div style={{
                        width: '18px',
                        height: '18px',
                        backgroundColor: '#f0f0f0',
                        borderRadius: '4px'
                    }}></div>
                    <div style={{
                        width: '150px',
                        height: '12px',
                        backgroundColor: '#f0f0f0',
                        borderRadius: '4px'
                    }}></div>
                </div>

                {/* phone skeleton */}
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <div style={{
                        width: '18px',
                        height: '18px',
                        backgroundColor: '#f0f0f0',
                        borderRadius: '4px'
                    }}></div>
                    <div style={{
                        width: '120px',
                        height: '12px',
                        backgroundColor: '#f0f0f0',
                        borderRadius: '4px'
                    }}></div>
                </div>

                {/* location skeleton */}
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <div style={{
                        width: '18px',
                        height: '18px',
                        backgroundColor: '#f0f0f0',
                        borderRadius: '4px'
                    }}></div>
                    <div style={{
                        width: '180px',
                        height: '12px',
                        backgroundColor: '#f0f0f0',
                        borderRadius: '4px'
                    }}></div>
                </div>
            </div>

            {/* social links skeleton */}
            <div
                className="d-flex justify-content-center align-items-center gap-3 position-absolute bottom-0 border-top"
                style={{
                    width: '100%',
                    height: "40px",
                    left: "0px",
                    borderTopColor: '#e0e0e0 !important'
                }}
            >
                {
                    [...Array(4)].map((_, i) => (
                        <div
                            key={i}
                            style={{
                                width: '18px',
                                height: '18px',
                                backgroundColor: '#f0f0f0',
                                borderRadius: '4px'
                            }}
                        ></div>
                    ))}
            </div>
        </div>
    );
};